import { lazy } from "react";
import { Redirect } from "react-router-dom";

const BrandsRoutes = [
  // {
  //   path: "/catalogo",
  //   component: lazy(() => import("../../views/brands/catalogOpen")),
  //   layout: "BlankLayout",
  //   meta: {
  //     publicRoute: true,
  //     contentWidth: "50px",
  //   },
  // },
  // {
  //   path: "/brands/catalogo",
  //   component: lazy(() => import("../../views/brands/catalog")),
  //   meta: {
  //     action: "true",
  //     resource: "brands_free_navigation",
  //   },
  // },
  // {
  //   path: "/brands/estoque",
  //   component: lazy(() => import("../../views/brands/stock")),
  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/budget",
  //   component: lazy(() => import("../../views/brands/budget")),
  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/pacotes",
  //   component: lazy(() => import("../../views/brands/packages")),

  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/envios",
  //   component: lazy(() => import("../../views/brands/shippings")),
  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/quotation/approve-quotations/:id",
  //   exact: true,
  //   component: lazy(() => import("../../views/brands/approveQuotation")),
  //   //layout: 'BlankLayout',

  //   meta: {
  //     navLink: "/brands/quotation/approve-quotations/",
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/entregas",
  //   component: lazy(() => import("../../views/brands/sentItems")),
  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/saldo",
  //   component: lazy(() => import("../../views/brands/balance")),
  //   exact: true,
  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
  // {
  //   path: "/brands/saldo/adicionar-saldo",
  //   component: lazy(() => import("../../views/brands/balance/addBalance")),
  //   meta: {
  //     authRoute: false,
  //     action: "true",
  //     resource: "brands_navigation",
  //   },
  // },
];

export default BrandsRoutes;
